import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';

interface ActionMenusProps {
  handleClickOptions: (e: React.MouseEvent<HTMLButtonElement>, index: number) => void;
  index: number;
  handleEditOptions: (index: number, type: number, id?: string) => void;
  className: string;
  clickedIndex: number;
  channelId: string;
}
export const ActionMenus = ({
  handleClickOptions,
  index,
  className,
  handleEditOptions,
  clickedIndex,
  channelId,
}: ActionMenusProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null as any);
  const open = Boolean(anchorEl);
  const handelClickMenu = (e: React.MouseEvent<HTMLButtonElement>, index: number) => {
    setAnchorEl(e.currentTarget);
    handleClickOptions(e, index);
  };
  return (
    <>
      <IconButton onClick={(e) => handelClickMenu(e, index)}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null as any)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          className,
        }}
      >
        <MenuItem onClick={() => handleEditOptions(clickedIndex, 1, channelId)}>
          {t('app.edit')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleEditOptions(clickedIndex, 2, channelId);
            setAnchorEl(null as any);
          }}
        >
          {t('button.fetch.classes')}
        </MenuItem>
        <MenuItem onClick={() => handleEditOptions(clickedIndex, 3, channelId)}>
          {t('app.cleanup')}
        </MenuItem>
      </Menu>
    </>
  );
};
